import type { Editor } from '@tiptap/core';
import { getHeightAndWidthFromDataUrl } from 'components/editor/ImageLibrary/helpers';
import { INLINE_IMAGE_NODE_NAME } from './inlineImageAttributes';

export const getInsertedImageSize = (
  natural: { width: number; height: number },
  containerWidth: number
): { width: number | null; height: number | null } => {
  if (!natural.width || !natural.height) return { width: null, height: null };

  const width = containerWidth > 0 ? Math.min(natural.width, containerWidth) : natural.width;
  return { width: Math.round(width), height: Math.round((width * natural.height) / natural.width) };
};

export const insertInlineImageFromSrc = async (editor: Editor, src: string, position: number): Promise<void> => {
  const natural = await getHeightAndWidthFromDataUrl(src);

  const { width, height } = getInsertedImageSize(natural, editor.view.dom.clientWidth);
  // The upload is async, so the document may have shrunk since the paste/drop position was captured.
  const safePosition = Math.min(position, editor.state.doc.content.size);

  editor.chain().focus().insertContentAt(safePosition, { type: INLINE_IMAGE_NODE_NAME, attrs: { src, width, height } }).run();
};
